import React							from 'react';

import Button							from '../Button';
import Badge							from '../Badge';

import {useAppSelector}					from '../../../app/hooks';
import {TabsProps}						from './interface';

import {ft_checkRight}					from '../../functions/userFunction';

import LANGUAGE							from '../../language';

import './Tabs.css';


function Tabs(props: TabsProps): JSX.Element {
	const user = useAppSelector(state => state.user.data);
	const lang = useAppSelector(state => state.settings.lang);

	const TEXTE = LANGUAGE(lang);

	const render: React.ReactElement[] = [];
	const activeIndex = props.data.findIndex(find => find.value === props.actual);

	props.data.forEach((data, i) => {
		if (data.right && !ft_checkRight(user, data.right))
			return;

		const onClick = () => {
			if (!data.soon && (!props.step || i <= activeIndex))
				return props.onChange(data.value);
		};
		if (props.button) {
			render.push(
				<Button
					onClick={onClick}
					key={`tabs-button-${i}`}
					fullWidth={!props.alignLeft}
					noFocusCss={props.noFocusCss}
					style={data.soon ? {cursor: 'not-allowed'} : {}}
					className={`tabsItem tabsButton ${props.textColorClass}`}
					size={typeof(props.button) === 'string' ? props.button : 'sm'}
					type={data.value === props.actual ? 'secondary' : 'tertiary-gray'}
				>
					{data.render}

					{data.soon &&
						<Badge
							size={'sm'}
							color={'gray'}
							text={TEXTE.global.soon}
						/>
					}
				</Button>
			);
		} else {
			render.push(
				<div
					onClick={onClick}
					key={`tabs-div-${i}`}
					className={`tabsItem ${!props.alignLeft && 'fullWidth'} ${props.textColorClass} ${data.value === props.actual && 'actual'} ${i < activeIndex && 'active'} ${props.button && 'tabsButton'}`}
				>
					{!data.notif ?
						data.render
						:
						<div>
							{data.render}
							<div className={'headerNotif'} />
						</div>
					}
				</div>
			);
		}

		if (props.alignLeft || props.button)
			render.push(<div key={`tabs-separator-${i}`} className={'tabsItemSeparator'} />);
	});

	return (
		<div className={`tabsMainContainer ${props.step && 'step'} ${props.button && 'tabsButton'}`} style={props.style}>
			<div>
				{render}
			</div>
		</div>
	);
}

export default Tabs;